module.exports = __webpack_public_path__ + "img/music.e3f07c68.png";